import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { AppLayoutPage } from "@/modules/app-layout/app-layout-page";
import AssetTypeTemplateAddButton from "@/modules/asset-type-templates/asset-type-templates-add-button";
import AssetTypeTemplatesTable from "@/modules/asset-type-templates/asset-type-templates-table";
import { ListProvider } from "@/modules/list";

const AssetTypeTemplatesListPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <BaseHeader title={t("global:technicalFormPlural")} />
      <AppLayoutPage>
        <ListProvider
          endpoint="entityTemplates"
          storageKey={STORAGE_KEYS.ENTITY_TEMPLATES}
        >
          <AssetTypeTemplatesTable
            extraActions={<AssetTypeTemplateAddButton />}
          />
        </ListProvider>
      </AppLayoutPage>
    </>
  );
};

export default AssetTypeTemplatesListPage;
